module.exports = __webpack_public_path__ + "9126979f001219ad290b7901e5f966c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/addons/images/logotypes/ceu.png
// module id = 677
// module chunks = 17